import ReducerGenerator from '../../lib/ReducerGenerator'

const generator = new ReducerGenerator('howie_service_area', '/howie_service_areas')
const reducer = generator.generate()

export default reducer
